import { render, staticRenderFns } from "./dataSourcePie.vue?vue&type=template&id=ca11cbb2"
import script from "./dataSourcePie.vue?vue&type=script&lang=js"
export * from "./dataSourcePie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports